:host {
  display: inline-block;
  position: relative;
}

.aha-settings-popover__wrapper {
  position: relative;
}

.aha-settings-popover__button {
  border-radius: var(--Common--border-radius);
  display: flex;
  color: var(--theme-secondary-text);
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 4px 7px;
  font-size: 14px;
  line-height: 14px;
}

.aha-settings-popover__icon {
  padding-right: 3px;
  font-size: 16px;
  color: var(--theme-secondary-text);
}

.aha-settings-popover__icon:hover {
  background-color: var(--theme-secondary-background);
}

.aha-settings-popover__button:hover {
  background-color: var(--theme-tertiary-background);
  color: var(--theme-primary-text);
}

.aha-settings-popover {
  z-index: 1039;
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: var(--Common--border-radius);
  padding: 25px 25px 10px 25px;
  color: var(--theme-light-text);
  background-color: var(--theme-tooltip-background);
}

.aha-settings-popover__content {
  display: block;
  font-size: 14px;
  font-weight: normal;
}

.aha-settings-popover__heading {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 1em;
  font-weight: bold;
}

.aha-settings-popover__close {
  cursor: pointer;
  float: right;
  margin-right: -20px;
  margin-top: -23px;
  margin-left: -16px;
  padding: 5px;
  color: var(--theme-light-text);
  opacity: 0.6;
}

.aha-settings-popover__close:hover {
  opacity: 1;
}
